import { Badge } from '@/components/ui';
import { entityTypeLabel, type PlatformEntityType } from './mapper-ui';

/** A SEED platform record's kind (School / University / Partner), or nothing when the platform does not say. */
export function EntityTypeBadge({ entityType }: { entityType: PlatformEntityType | undefined }) {
  const label = entityTypeLabel(entityType);
  if (label === null) return null;
  return (
    <Badge tone="neutral" variant="outline">
      {label}
    </Badge>
  );
}
